import "./instrument";
import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./index.css";
import { captureSignupAttribution } from "@/modules/auth/utils/signupAttribution";

import App from "./App.tsx";
import { registerColocaZodErrorMap } from "./shared/lang/zodErrorMap";

registerColocaZodErrorMap();
captureSignupAttribution();

createRoot(document.getElementById("root")!, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
